export default {"src":"/_next/static/media/webpack-server.72d20521.svg","height":1143,"width":2346,"blurWidth":0,"blurHeight":0};